import { Utenti } from './../../Admin/models/utenti';
import { Azienda } from 'src/app/Admin/models/Azienda';
import { Collo } from './Collo';
import { Files } from 'src/app/shared/models/File';
export class Spedizione {
  id: number;
  creaCliente: boolean;
  creaDestinatario: boolean;
  note: string;
  data_inizio_prevista: string;
  cliente: number;
  corriere: string | number;
  corriereObject: Azienda;
  clienteObject: Azienda;
  corrieriObject: Azienda[];
  clientiObject: Azienda[];
  ldv: string;
  mittente: Azienda;
  destinatario: Azienda;
  colli: Collo[];
  spedita: boolean;
  lavorata: boolean;
  manager: Utenti;
  files: Files[];
  link: string;
  isSelected: boolean;
  stato
  smsD: boolean;
  smsM: boolean;
  standby: boolean;
  progressivo: number;
  clienteHaPagato: boolean;
  costoSpedizione: number;
  costoContrassegno: number; // parametro contrassegno
  valoreContrassegno: number;// parametro contrassegno
  dareCliente: number; // parametro contrassegno
  clientePagato: boolean; // parametro contrassegno
  costoImballaggio: number; //
  costoAssicurazione: number;// assicurazione
  valoreAssicurazione: number;// assicurazione
  t10: number;//o t10 o t12 importo
  t12: number;
// admin:
  costoCorriere: any;
  pagatoCorriere: boolean;
  costoAgenzia: number;
  pagatoAgenzia: boolean;
  ritiro: boolean;
  internazionale: boolean;
  triangolazione?: boolean;
  costoRitiro: number;
  costoTriangolazione: number;
  costoPreavTel: number;
  costoVarie: number;
  varie: string;
  fattura: boolean;
  allegato?: { allegato: string; file: string; descrizione: string }[];
  costoDeposito?: number;
  costoConsegnaPiano?: number;
  tipoCollo?: string;
  nazionale?: boolean;
  pratica?: boolean;
  dataPratica?: string;
  codicePratica?:string;
  notePratica?:string;
  praticaChiusa?:boolean;
  costoLaera?: number;
  pagatoLaera?: boolean;
  dataRitiroFiliale?: any;
  codiceRitiro?:any;
  email?: boolean;
  constructor() {
    this.mittente = { nome: "", indirizzo: "", cap: "", citta: "", provincia: "", nazione: [{id: "IT", label: "Italia"}], tel: "", country:"+39 " };
    this.destinatario = { nome: "", indirizzo: "", cap: "", citta: "", provincia: "", nazione: [{id: "IT", label: "Italia"}], tel: "", country:"+39 " };
    this.colli = [];
    this.clientePagato = false;
    this.pagatoCorriere = false;
    this.pagatoAgenzia = false;
    this.creaCliente = true;
    this.creaDestinatario = true;
    this.clienteHaPagato = false;
    this.spedita = false;
    this.lavorata = false;
    this.standby = false;
    this.internazionale = undefined;
    this.ritiro = false;
    this.pratica = false;
    this.praticaChiusa = false;
    this.internazionale = undefined;


  }
}
